<template>
  <h1 class="title">
    Investments
  </h1>

  <investment-form class="mb-6" />

  <investment-list />
</template>

<script>
import InvestmentForm from './InvestmentForm.vue';
import InvestmentList from './InvestmentList.vue';

export default {
  name: 'Investments',

  components: {
    InvestmentForm,
    InvestmentList,
  },
};
</script>
